import { render, staticRenderFns } from "./DetailOne.vue?vue&type=template&id=123df35b&scoped=true"
import script from "./DetailOne.vue?vue&type=script&lang=ts"
export * from "./DetailOne.vue?vue&type=script&lang=ts"
import style0 from "./DetailOne.vue?vue&type=style&index=0&id=123df35b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123df35b",
  null
  
)

export default component.exports